module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-box",
    class: {
      'show': _vm.isShow, 'hide': !_vm.isShow
    }
  }, [_c('div', {
    staticClass: "tip-dialog-box"
  }, [_c('div', {
    staticClass: "tip-dialog"
  }, [_vm._v("\n            Our site uses cookies to enhance your experience and to help us better understand how you use our website. For more information, please review our "), _c('a', {
    staticClass: "f-cursor s-blue",
    on: {
      "click": function($event) {
        return _vm.onJump('/privacy-policy')
      }
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" and "), _c('a', {
    staticClass: "f-cursor s-blue",
    on: {
      "click": function($event) {
        return _vm.onJump('/terms-of-use')
      }
    }
  }, [_vm._v("Terms of Use")]), _vm._v(". \n        ")]), _vm._v(" "), _c('button', {
    staticClass: "got-btn f-margin-center f-mt20",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Got it")]), _vm._v(" "), _c('img', {
    staticClass: "ico-close",
    attrs: {
      "src": require("../assets/images/ic-close-black.png")
    },
    on: {
      "click": _vm.onClose
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-585fdfa5"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tip-dialog.vue
// module id = 694
// module chunks = 17